/**
 * @description 根据cookie的名称，获取cookie的值
 * @param       {[type]}                 c_name [cookie的名称]
 * @return      {[type]}                        [description]
 */
const getCookie = (cName: string): string => {
  if (document.cookie.length > 0) {
    let cStart = document.cookie.indexOf(cName + '=');
    if (cStart != -1) {
      cStart = cStart + cName.length + 1;
      let cEnd = document.cookie.indexOf(';', cStart);
      if (cEnd == -1) cEnd = document.cookie.length;
      return unescape(document.cookie.substring(cStart, cEnd));
    }
  }
  return '';
};

export default getCookie;
